import { Divider, Header } from 'semantic-ui-react'
import { TodayActivitySection } from './TodayActivitySection/TodayActivitySection'
import { MyParkSection } from './MyParkSection/MyParkSection'
import { IntegrationSection } from './IntegrationSection/IntegrationSection'
import useUser from '../Shared/UserProvider/useUser'
import { isProviderAPos } from '../../services/Provider/Provider.service'


const Dashboard = () => {
    const { user } = useUser()

    return (
      <>
          <Divider horizontal>
              <Header as="h4" color="teal">
                  Recommandations
              </Header>
          </Divider>

          <TodayActivitySection />

          <MyParkSection />

          <Divider horizontal>
              <Header as="h4" color="teal">
                  Mon offre
              </Header>
          </Divider>

          {isProviderAPos(user.provider) && <IntegrationSection />}
      </>
    )
}

export { Dashboard }
